import enviro from 'enviro';
const HUBSPOT_PORTAL_IDS_PROD = new Set([137828, 50619635, 50958693]);
const HUBSPOT_PORTAL_IDS_QA = new Set([885765335, 911635575, 913439751]);
export const getIsHubSpotter = userInfo => {
  var _userInfo$user;
  return userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.emails) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.some(email => /@hubspot\.com$/.test(email));
};
export const getIsHubSpotContent = hubId => {
  if (hubId === undefined) {
    return false;
  }
  const expectedPortalIds = enviro.isQa() ? HUBSPOT_PORTAL_IDS_QA : HUBSPOT_PORTAL_IDS_PROD;
  return expectedPortalIds.has(hubId);
};